/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable new-cap */
/* eslint-disable import/prefer-default-export */
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

/**
 * Sanitize a filename by replacing invalid characters with underscores
 * @param {string} name
 * @returns {string}
 */
const sanitizeFileName = (name) =>
  // Remove leading/trailing spaces and replace invalid characters
  name.trim().replace(/[\\/\\:*?"<>|]/g, '_');
export const downloadPDF = async (element, fileName) => {
  if (!element) {
    console.error('No element provided for PDF generation.');
    return;
  }

  const safeFileName = sanitizeFileName(fileName || 'document');

  try {
    const canvas = await html2canvas(element, { scale: 2, scrollY: -window.scrollY });
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    let heightLeft = pdfHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
    heightLeft -= pdf.internal.pageSize.getHeight();

    while (heightLeft > 0) {
      position = heightLeft - pdfHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
      heightLeft -= pdf.internal.pageSize.getHeight();
    }

    pdf.save(`${safeFileName}.pdf`);
  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};
